/**
 * @file コンポーネント：検索執刀医絞り込み DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ListItemToggle } from "~/src/components/uiparts/ListItemToggle";

// スタイル読み込み
import { StyledList } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledList>
            {props.list.map((item, index) => (
                <ListItemToggle key={"item-" + index} {...item} />
            ))}
        </StyledList>
    );
};
